import axiosInstance from "./axiosInstance";
export const globalSearch = async (q, signal) => (await axiosInstance.get("/search", { params: { q }, signal })).data;
